export default function MyProgramUnavailableScreen() {
  return (
    <div
      style={{
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: 1000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '40px',
        borderRadius: '20px'
      }}
    >
      <div
        style={{
          padding: '40px',
          color: '#fff',
          textAlign: 'left',
          display: 'flex',
          gap: '20px',
          maxWidth: '800px',
        }}
      >
        <img
          src="/images/dashboard/program-unavailable.svg"
          alt="paused-program"
          style={{
            width: '120px',
            height: '120px',
          }}
        />
        <div>
          <h3
            style={{
              color: '#E55B8C',
              fontSize: '24px',
              fontWeight: '700',
            }}
          >
            Programs Temporarily Unavailable
          </h3>
          <p
            style={{
              marginTop: '10px',
              fontSize: '20px',
              color: '#FFFFFF',
              fontWeight: '400',
            }}
          >
            We've paused your exercise program since you reported pain or an
            injury. Your CareSpace coach will review your condition and create
            a new plan for your recovery. Take care, and we'll get you back on
            track soon!
          </p>
        </div>
      </div>
    </div>
  )
}

